import { __decorate, __param } from 'tslib';
import { ElementRef, Inject, Output, Directive, NgModule } from '@angular/core';
import { typedFromEvent, preventDefault } from '@taiga-ui/cdk/observables';
import { TuiDestroyService } from '@taiga-ui/cdk/services';
import { isPresent } from '@taiga-ui/cdk/utils/miscellaneous';
import { merge, Observable } from 'rxjs';
import { map, filter, switchMap, mapTo, startWith, distinctUntilChanged, takeUntil } from 'rxjs/operators';

// @dynamic
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'rxjs';
let TuiDroppableDirective = class TuiDroppableDirective {
    constructor({ nativeElement }, destroy$) {
        this.tuiDroppableDropped = typedFromEvent(nativeElement, 'drop').pipe(preventDefault(), map(event => event.dataTransfer), filter(isPresent));
        this.tuiDroppableDragOverChange = typedFromEvent(nativeElement, 'dragenter').pipe(switchMap(({ target, dataTransfer }) => merge(typedFromEvent(nativeElement, 'dragleave').pipe(filter(event => event.target === target)), typedFromEvent(nativeElement, 'drop')).pipe(mapTo(null), startWith(dataTransfer))), distinctUntilChanged((a, b) => (!!a && !!b) || (!a && !b)));
        // Required by Drag and Drop API to stop redirecting
        typedFromEvent(nativeElement, 'dragover')
            .pipe(preventDefault(), takeUntil(destroy$))
            .subscribe();
    }
};
TuiDroppableDirective.ɵfac = function TuiDroppableDirective_Factory(t) { return new (t || TuiDroppableDirective)(ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(TuiDestroyService)); };
TuiDroppableDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiDroppableDirective, selectors: [["", "tuiDroppableDropped", ""], ["", "tuiDroppableDragOverChange", ""]], outputs: { tuiDroppableDropped: "tuiDroppableDropped", tuiDroppableDragOverChange: "tuiDroppableDragOverChange" }, features: [ɵngcc0.ɵɵProvidersFeature([TuiDestroyService])] });
TuiDroppableDirective.ctorParameters = () => [
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TuiDestroyService,] }] }
];
__decorate([
    Output()
], TuiDroppableDirective.prototype, "tuiDroppableDropped", void 0);
__decorate([
    Output()
], TuiDroppableDirective.prototype, "tuiDroppableDragOverChange", void 0);
TuiDroppableDirective = __decorate([ __param(0, Inject(ElementRef)),
    __param(1, Inject(TuiDestroyService))
], TuiDroppableDirective);

let TuiDroppableModule = class TuiDroppableModule {
};
TuiDroppableModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiDroppableModule });
TuiDroppableModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiDroppableModule_Factory(t) { return new (t || TuiDroppableModule)(); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiDroppableDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiDroppableDropped], [tuiDroppableDragOverChange]',
                providers: [TuiDestroyService]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc1.Observable, decorators: [{
                type: Inject,
                args: [TuiDestroyService]
            }] }]; }, { tuiDroppableDropped: [{
            type: Output
        }], tuiDroppableDragOverChange: [{
            type: Output
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiDroppableModule, { declarations: [TuiDroppableDirective], exports: [TuiDroppableDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiDroppableModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiDroppableDirective],
                exports: [TuiDroppableDirective]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiDroppableDirective, TuiDroppableModule };

//# sourceMappingURL=taiga-ui-cdk-directives-droppable.js.map